import { __assign } from "tslib";
import React, { memo } from 'react';
import { Orientation } from '../../types';
var Tick = function (_a) {
    var _b;
    var x = _a.x, y = _a.y, orientation = _a.orientation, size = _a.size, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c, children = _a.children;
    var linePosition = orientation === Orientation.HORIZONTAL ? size : -Math.abs(size);
    var position = (_b = {},
        _b[orientation === Orientation.HORIZONTAL ? 'y2' : 'x2'] = linePosition,
        _b);
    return (React.createElement("g", { transform: "translate(" + x + ", " + y + ")" },
        React.createElement("line", __assign({ stroke: color }, position)),
        children));
};
export default memo(Tick);
